<template>
  <input class="input-ref" ref="inputRef" type="text" />
</template>

<script>
import flatpickr from "flatpickr";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";
import "flatpickr/dist/flatpickr.min.css";
import "flatpickr/dist/plugins/monthSelect/style.css";

export default {
  name: "MonthPicker",
  props: {
    modelValue: {
      type: String,
      default: "",
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      pickerInstance: null,
    };
  },
  mounted() {
    this.pickerInstance = flatpickr(this.$refs.inputRef, {
      locale: Portuguese,
      altInput: true,
      altFormat: "F [de] Y", // exibição
      dateFormat: "m/Y", // valor interno
      defaultDate: this.modelValue || null,
      plugins: [
        new monthSelectPlugin({
          shorthand: false,
        }),
      ],
      onChange: ([date]) => {
        if (date) {
          const formatted = flatpickr.formatDate(date, "m/Y");
          this.$emit("update:modelValue", formatted);
        }
      },
    });
    if (this.pickerInstance.altInput) {
      this.pickerInstance.altInput.placeholder = "Selecione o mês/ano";
    }
  },
  methods: {
    // Component methods
  },
  watch: {
    modelValue(newVal) {
      if (this.pickerInstance && newVal) {
        console.log(this.pickerInstance, newVal);
        this.pickerInstance.setDate(newVal, true, "m/Y");
        console.log(this.pickerInstance);
      }
    },
  },
  beforeUnmount() {
    if (this.pickerInstance) {
      this.pickerInstance.destroy();
    }
  },
};
</script>

<style scoped>
.input-ref {
  border-radius: 10px;
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  border: 1px solid #ced4da;
}
</style>
